import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

const GmailTemporaryStatsSchema = new mongoose.Schema({
  user: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.USER },
  archivedEmails: { type: [String], default: [] },
  urgentEmails: { type: [String], default: [] },
  totalReceived: { type: Number, default: 0 },
  totalDrafts: { type: Number, default: 0 },
  draftedEmails: { type: [String], default: [] },
});

export type T_GmailTemporaryStatsActions = InferSchemaType<typeof GmailTemporaryStatsSchema>;

export type T_GmailTemporaryStatsDocument = T_GmailTemporaryStatsActions &
  Document & {
    _id: string;
  };

export { GmailTemporaryStatsSchema };
